export default __webpack_public_path__ + "static/feature-importances-sales--mobile-b560d9200bc9aab08dce6be5676e8be2.png";